import { getOffScreenContext } from '@antv/g-base';
export default function isPointInPath(shape, x, y) {
    var ctx = getOffScreenContext();
    shape.createPath(ctx);
    return ctx.isPointInPath(x, y);
}
//# sourceMappingURL=point-in-path.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g-canvas/esm/util/in-path/point-in-path.js
// module id = null
// module chunks = 